/** @format */

import { api } from 'utility';
import { getCheckAsyncConfig } from 'URLs';

let configPromise = null;

const API_PATH_PATTERN = /(^|\/)api(?:\/|$)/i;
const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z\d+.-]*:)?\/\//i;

function joinUrlParts(baseUrl, path) {
  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

function hasApiPath(url) {
  return API_PATH_PATTERN.test(
    new URL(url, window.location.origin).pathname,
  );
}

function toAbsoluteUrl(url) {
  if (ABSOLUTE_URL_PATTERN.test(url)) {
    return url;
  }

  const path = url.startsWith('/') ? url : `/${url}`;

  return new URL(path, window.location.origin).toString();
}

function getServiceConfigUrl() {
  const endpoint = getCheckAsyncConfig();

  if (hasApiPath(endpoint)) {
    if (ABSOLUTE_URL_PATTERN.test(endpoint)) {
      return endpoint;
    }

    const apiHost = process.env.REACT_APP_API_JAVA || window.location.origin;

    return new URL(
      endpoint.startsWith('/') ? endpoint : `/${endpoint}`,
      apiHost,
    ).toString();
  }

  const apiHost = process.env.REACT_APP_API_JAVA || '';
  const configuredBaseUrl = process.env.REACT_APP_BASE_URL || '';
  let baseUrl = ABSOLUTE_URL_PATTERN.test(configuredBaseUrl)
    ? configuredBaseUrl
    : joinUrlParts(apiHost, configuredBaseUrl);

  if (!baseUrl) {
    baseUrl = window.location.origin;
  }

  if (!hasApiPath(baseUrl)) {
    baseUrl = joinUrlParts(baseUrl, '/api');
  }

  return toAbsoluteUrl(joinUrlParts(baseUrl, endpoint));
}

export function serviceConfigCheckAsync() {
  if (!configPromise) {
    const token = localStorage.getItem('TOKEN') ?? '';

    const serviceConfigUrl = getServiceConfigUrl();

    configPromise = api.axios
      .get(serviceConfigUrl, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        skipServiceConfig: true,
        skipAuthRefresh: false,
        ignoreCancelToken: true,
        noToast: true,
      })
      .then((response) => response.data)
      .catch((error) => {
        configPromise = null;

        throw error;
      });
  }

  return configPromise;
}

/**
 * برای پاک کردن Promise کش‌شده، در صورت نیاز.
 */
export function clearServiceConfigRequestCache() {
  configPromise = null;
}

